import { IUser, IUserSearchResults } from "services/types";
import { Following } from "components/subscribers";
import { useFollowing } from "../hooks/useFollowing";
import { UserCount } from ".";

interface IProps {
  userName: string;
  query: any;
}

export const UserList = (props: IProps) => {
  const { following, toggleSubscription } = useFollowing();
  const { data, status, hasNextPage, fetchNextPage } = props.query();

  if (status !== "success") {
    return <></>;
  }

  const users = data?.pages.reduce((acc: IUser[], page: IUserSearchResults) => {
    return [...acc, ...page.items];
  }, []) || [];

  const handleFollow = (id: string) => {
    toggleSubscription(id);
  };

  return (
    <div className="SubscribersPage-Content">
      <UserCount
        count={data?.pages[0].total || 0}
      />

      <Following
        users={users}
        total={data.pages[0].total}
        hasMore={hasNextPage}
        fetchMore={fetchNextPage}
        following={following}
        handleFollow={handleFollow}
      />
    </div>
  );
};
